import { Filter } from '#/common/components/DataGrid';

// Helper function to extract filter value from permanentFilters
const getPermanentFilterValue = (
  filterKey: string,
  permanentFilters: Filter[] | undefined | null,
): string | undefined => {
  if (!permanentFilters || permanentFilters.length === 0) return undefined;

  for (const filter of permanentFilters) {
    if (Array.isArray(filter)) {
      // Handle nested array structure like [['assetId', '=', 'value'], 'and', ['tenantId', '=', 'value']]
      if (Array.isArray(filter[0])) {
        for (const subFilter of filter) {
          if (Array.isArray(subFilter) && subFilter[0] === filterKey && subFilter[1] === '=') {
            return subFilter[2] as string;
          }
        }
      }
      // Handle simple array structure like ['assetId', '=', 'value']
      else if (filter[0] === filterKey && filter[1] === '=') {
        return filter[2] as string;
      }
    }
  }
  return undefined;
};

export default getPermanentFilterValue;
